// extracted by mini-css-extract-plugin
module.exports = {"root":"NewTabLink_root__1QD0P"};